module.exports = __webpack_public_path__ + "img/dz.f904aff5.svg";